<template>
  <main>
    <div class="container-fluid">
      <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
          <button class="nav-link active" id="will-process-content-tab" data-bs-toggle="pill" data-bs-target="#will-process-content"
            type="button" role="tab" aria-controls="will-process-content" aria-selected="true"> 警報查詢與處理 </button>
        </li>
        <!-- <li class="nav-item" role="presentation">
          <button class="nav-link active" id="will-process-content-tab" data-bs-toggle="pill" data-bs-target="#will-process-content"
            type="button" role="tab" aria-controls="will-process-content" aria-selected="true"> 警報處理 </button>
        </li> -->
        
        <!-- <li class="nav-item" role="presentation">
          <button class="nav-link" id="search-content-tab" data-bs-toggle="pill" data-bs-target="#search-content" 
            type="button" role="tab" aria-controls="search-content" aria-selected="false">警報查詢 </button>
        </li> -->
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="sos-cross-content-tab" data-bs-toggle="pill" data-bs-target="#sos-cross-content" 
            type="button" role="tab" aria-controls="sos-cross-content" aria-selected="false">跨區比較 </button>
        </li>
      </ul>

      <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
        <will-process></will-process>
        <!-- <search-process></search-process> -->
        <cross-region></cross-region>
      </div>
    </div>
  </main>
</template>

<script>
import willProcess from './willProcess.vue'
// import searchProcess from './searchProcess.vue';
import crossRegion from './crossRegion.vue'



export default {
  components: { willProcess, crossRegion},
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
 
  },
  mounted() {

  },
};
</script>

<style>
</style>
